import * as Yup from 'yup';

export const schema = Yup.object().shape({
  dataHoraInicioAtendimento: Yup.date().nullable(true).required('Informe a hora do início do atendimento'),
  dataHoraTerminoAtendimento: Yup.date().nullable(true).required('Informe a hora do término do atendimento'),
});
